import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=29c803f8"
import script from "./ReviewSection.vue?vue&type=script&lang=ts"
export * from "./ReviewSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports